export const START_MASS_MANAGEMENT_FETCH = "massManagement/startFetch" as const;
export const FINISH_MASS_MANAGEMENT_FETCH = "massManagement/finishFetch" as const;

export type StartMassManagementFetchType = {
    type: typeof START_MASS_MANAGEMENT_FETCH;
    loadData: boolean;
};
export type FinishMassManagementFetchType = {
    type: typeof FINISH_MASS_MANAGEMENT_FETCH;
    exceedingKilogram: number;
    isError: boolean;
};

export const startMassManagementFetch = (loadData: boolean = true): StartMassManagementFetchType => ({
    type: START_MASS_MANAGEMENT_FETCH,
    loadData,
});
export const finishMassManagementFetch = (
    exceedingKilogram: number,
    isError: boolean,
): FinishMassManagementFetchType => ({
    type: FINISH_MASS_MANAGEMENT_FETCH,
    exceedingKilogram,
    isError,
});

export type MassManagementActionType = StartMassManagementFetchType | FinishMassManagementFetchType;
